export default __webpack_public_path__ + "static/media/numpy.fd2aba20.png";